import type {
  CartAttribute,
  CartProduct,
} from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import { MARKETPLACE_SELLER_ID_SERVICEBUND } from "constants/common";
import type { Attribute, BaseProduct } from "types/Product";
import { isAttributeMap, isMarketplaceArticle } from "types/Product";

export const resolveSellerIdentifierForArticle = (
  article: BaseProduct | CartProduct
) => {
  if (!isMarketplaceArticle(article)) {
    return MARKETPLACE_SELLER_ID_SERVICEBUND;
  }

  const sellerIdMatch = /^MP-(?<sellerId>[^-]+)-.*$/.exec(article.partNumber);
  const { sellerId } = sellerIdMatch?.groups ?? { sellerId: undefined };

  if (sellerId) {
    return sellerId;
  }

  let attributes: Attribute[] | CartAttribute[];
  if (isAttributeMap(article.attributes)) {
    attributes = article.attributes["-"] ?? [];
  } else {
    attributes = article.attributes;
  }

  return (
    attributes
      .find((a) => a.identifier === "MP_SELLER")
      ?.values?.map((av) => av.value)
      .find((v) => !!v) ?? MARKETPLACE_SELLER_ID_SERVICEBUND
  );
};
